import { gql, QueryHookOptions } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';

const query = gql`
  query getWhatsAppInfobipLocales {
    getWhatsAppInfobipLocales
      { 
        code 
        displayName 
      }
    }
`;

export const useGetWhatsAppInfobipLocales = (options?: QueryHookOptions) => {
  const { data, isLoading, error } = useGraphql<{
    getWhatsAppInfobipLocales: {
      code: string;
      displayName: string;
    }[];
  }>(query, options);

  return {
    data: data?.getWhatsAppInfobipLocales,
    isLoading,
    error,
  };
};
